module.exports = __webpack_public_path__ + "img/henan.0eaed904.png";